import React from 'react'

interface ClickablePhoneProps {
  phone: string
  className?: string
  showIcon?: boolean
  iconClassName?: string
}

const ClickablePhone: React.FC<ClickablePhoneProps> = ({
  phone,
  className = "",
  showIcon = false,
  iconClassName = ""
}) => {
  // Убираем все символы кроме цифр для href="tel:"
  const cleanPhone = phone.replace(/\D/g, '')

  return (
    <a
      href={`tel:${cleanPhone}`}
      className={`${className}`}
      title="Нажмите для звонка"
    >
      {showIcon && <span className={`mr-2 ${iconClassName}`}>📱</span>}
      {phone}
    </a>
  )
}

export default ClickablePhone
